/**
 * @architecture-header 1
 * @layer module
 * @domain activities
 * @responsibility Advance uploaded activities through the parsing progress simulation.
 * @state-owner dataset store
 * @allowed-imports React; dataset store; shared demo constants
 * @forbidden component markup; direct API client
 * @public-api workspace shell
 * @side-effects schedules a repeating progress timer while a parse is in flight
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { useEffect } from 'react';
import { QUESTIONS } from '../../../shared/lib/demo-data';
import { useDatasetStore } from '../../../shared/model/dataset-store';

const TICK_MS = 700;

/** The block inside `doUpload()`. */
export function useParsingSimulation() {
  const parsingCount = useDatasetStore(
    (state) => state.activities.filter((item) => item.status === 'parsing').length,
  );

  useEffect(() => {
    if (!parsingCount) return;
    const timer = window.setInterval(() => {
      const store = useDatasetStore.getState();
      for (const activity of store.activities) {
        if (activity.status !== 'parsing') continue;
        const percent = (activity.parsedPercent ?? 0) + Math.round(6 + Math.random() * 13);
        if (percent >= 100) {
          const pending = activity.reviewed.filter((value) => !value).length;
          store.updateActivity(activity.id, {
            parsedPercent: 100,
            status: 'review',
            questionCount: QUESTIONS.length,
            needsReview: pending,
          });
        } else {
          store.updateActivity(activity.id, { parsedPercent: percent });
        }
      }
    }, TICK_MS);
    return () => window.clearInterval(timer);
  }, [parsingCount]);
}
